import { type QueryClient } from '@tanstack/react-query';

export const refreshRecommendedCredentials = (queryClient: QueryClient) =>
  Promise.all(
    [
      'RecommendedCredentialsJobCounts',
      'RecommendedCredentialsJobCountsSummary',
      'GetMissingConditions',
    ].map((operationName) => queryClient.invalidateQueries({ queryKey: [operationName] })),
  );
